module.exports = __webpack_public_path__ + "img/onlineBuy.a7b1d29e.png";